@if (!authService.authReady()) {
<app-global-loader></app-global-loader>
} @else {
<div>
  <app-header></app-header>
  <router-outlet />
  <p-toast position="bottom-center" />
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
  <app-uploading-toast />
</div>
}
